export class YearsExperience {
    readonly id: number;
    readonly shortText: string;
    readonly shortTextPlus: string;
    readonly value: number;

    constructor(id: number, shortText: string, shortTextPlus: string, value: number) {
        this.id = id;
        this.shortText = shortText;
        this.shortTextPlus = shortTextPlus;
        this.value = value;
    }

    public static Zero = new YearsExperience(undefined, "zero years", "zero years", 0);
    public static One = new YearsExperience(3276, "1", "1+", 1);
    public static Two = new YearsExperience(3277, "2", "2+", 2);
    public static Three = new YearsExperience(3278, "3", "3+", 3);
    public static Four = new YearsExperience(3279, "4", "4+", 4);
    public static Five = new YearsExperience(3280, "5", "5+", 5);
    public static Six = new YearsExperience(3281, "6", "6+", 6);
    public static Seven = new YearsExperience(3282, "7", "7+", 7);
    public static Eight = new YearsExperience(3283, "8", "8+", 8);
    public static Nine = new YearsExperience(3284, "9", "9+", 9);
    public static Ten = new YearsExperience(3285, "10+", "10+", 10);

    public static AsArrayAll = () => [
        YearsExperience.Zero,
        YearsExperience.One,
        YearsExperience.Two,
        YearsExperience.Three,
        YearsExperience.Four,
        YearsExperience.Five,
        YearsExperience.Six,
        YearsExperience.Seven,
        YearsExperience.Eight,
        YearsExperience.Nine,
        YearsExperience.Ten,
    ];

    public static asArrayConfigure = () =>
        YearsExperience.AsArrayAll().filter(ye => ye.id !== undefined);

    public static fromId = (id: number) =>
        YearsExperience.AsArrayAll().find(ye => ye.id === id);

    public static fromValue = (value: number) =>
        YearsExperience.AsArrayAll().find(y => y.value === value);
}
